module.exports = __webpack_public_path__ + "static/media/logo-light.69a26a57.svg";